export default {"src":"/_next/static/media/profile.fbcb39d9.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};